import { render, staticRenderFns } from "./customer-delete.vue?vue&type=template&id=cd7d78b4&"
import script from "./customer-delete.vue?vue&type=script&lang=js&"
export * from "./customer-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports